var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "box" }, [
      _vm._m(0),
      _c("div", { staticClass: "columns" }, [
        _vm._m(1),
        _vm._v(
          "\n          " +
            _vm._s(_vm.setEmail(_vm.userData.email)) +
            "\n          "
        ),
        _c("div", { staticClass: "column is-6" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.userData.email,
                expression: "userData.email"
              }
            ],
            staticClass: "input",
            attrs: { type: "email", placeholder: "example@example.com" },
            domProps: { value: _vm.userData.email },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.userData, "email", $event.target.value)
                },
                function($event) {
                  _vm.setEmail($event.target.value)
                }
              ]
            }
          })
        ]),
        _c("div", { staticClass: "column is-4" }, [
          !_vm.$v.email.email
            ? _c("div", { staticClass: "has-text-danger" }, [
                _vm._v("Email format not correct")
              ])
            : _vm._e()
        ])
      ]),
      _c("div", { staticClass: "columns" }, [
        _vm._m(2),
        _c("div", { staticClass: "column is-6" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.userData.password,
                expression: "userData.password"
              }
            ],
            staticClass: "input",
            attrs: {
              placeholder: "Leave blank if you wouldn't change",
              type: "password"
            },
            domProps: { value: _vm.userData.password },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.userData, "password", $event.target.value)
                },
                function($event) {
                  _vm.setPassword($event.target.value)
                }
              ]
            }
          })
        ]),
        _c("div", { staticClass: "column is-4" }, [
          !_vm.$v.password.minLength
            ? _c("div", { staticClass: "has-text-danger" }, [
                _vm._v(
                  "Password must have at least " +
                    _vm._s(_vm.$v.password.$params.minLength.min) +
                    " letters."
                )
              ])
            : _vm._e()
        ])
      ]),
      _c("div", { staticClass: "columns" }, [
        _vm._m(3),
        _c("div", { staticClass: "column is-6" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.userData.confirmPassword,
                expression: "userData.confirmPassword"
              }
            ],
            staticClass: "input",
            attrs: {
              type: "password",
              placeholder: "Leave blank if you wouldn't change"
            },
            domProps: { value: _vm.userData.confirmPassword },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.userData, "confirmPassword", $event.target.value)
                },
                function($event) {
                  _vm.setRepeatPassword($event.target.value)
                }
              ]
            }
          })
        ]),
        _c("div", { staticClass: "column is-4" }, [
          !_vm.$v.repeatPassword.sameAsPassword
            ? _c("div", { staticClass: "has-text-danger" }, [
                _vm._v("Passwords must be identical.")
              ])
            : _vm._e()
        ])
      ]),
      _c("div", { staticClass: "columns" }, [
        _vm._m(4),
        _c("div", { staticClass: "column is-6" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.userData.customerName,
                expression: "userData.customerName"
              }
            ],
            staticClass: "input",
            attrs: { type: "text", placeholder: "example" },
            domProps: { value: _vm.userData.customerName },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.userData, "customerName", $event.target.value)
              }
            }
          })
        ])
      ]),
      _c("div", { staticClass: "columns" }, [
        _vm._m(5),
        _c("div", { staticClass: "column is-6" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.userData.firstName,
                expression: "userData.firstName"
              }
            ],
            staticClass: "input",
            attrs: { type: "text", placeholder: "example" },
            domProps: { value: _vm.userData.firstName },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.userData, "firstName", $event.target.value)
              }
            }
          })
        ])
      ]),
      _c("div", { staticClass: "columns" }, [
        _vm._m(6),
        _c("div", { staticClass: "column is-6" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.userData.lastName,
                expression: "userData.lastName"
              }
            ],
            staticClass: "input",
            attrs: { type: "text", placeholder: "example" },
            domProps: { value: _vm.userData.lastName },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.userData, "lastName", $event.target.value)
              }
            }
          })
        ])
      ]),
      _c("div", { staticClass: "columns" }, [
        _vm._m(7),
        _c("div", { staticClass: "column is-6" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.userData.branch,
                expression: "userData.branch"
              }
            ],
            staticClass: "input",
            attrs: { type: "text" },
            domProps: { value: _vm.userData.branch },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.userData, "branch", $event.target.value)
              }
            }
          })
        ])
      ]),
      _c("div", { staticClass: "columns" }, [
        _vm._m(8),
        _c("div", { staticClass: "column is-6" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.userData.address1,
                expression: "userData.address1"
              }
            ],
            staticClass: "input",
            attrs: { type: "text", placeholder: "Address1" },
            domProps: { value: _vm.userData.address1 },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.userData, "address1", $event.target.value)
              }
            }
          })
        ])
      ]),
      _c("div", { staticClass: "columns" }, [
        _vm._m(9),
        _c("div", { staticClass: "column is-6" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.userData.address2,
                expression: "userData.address2"
              }
            ],
            staticClass: "input",
            attrs: { type: "text", placeholder: "Address2" },
            domProps: { value: _vm.userData.address2 },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.userData, "address2", $event.target.value)
              }
            }
          })
        ])
      ]),
      _c("div", { staticClass: "columns" }, [
        _vm._m(10),
        _c("div", { staticClass: "column is-6" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.userData.address3,
                expression: "userData.address3"
              }
            ],
            staticClass: "input",
            attrs: { type: "text", placeholder: "Province" },
            domProps: { value: _vm.userData.address3 },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.userData, "address3", $event.target.value)
              }
            }
          })
        ])
      ]),
      _c("div", { staticClass: "columns" }, [
        _vm._m(11),
        _c("div", { staticClass: "column is-6" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.userData.address4,
                expression: "userData.address4"
              }
            ],
            staticClass: "input",
            attrs: { type: "text", placeholder: "Zipcode" },
            domProps: { value: _vm.userData.address4 },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.userData, "address4", $event.target.value)
              }
            }
          })
        ])
      ]),
      _c("div", { staticClass: "columns" }, [
        _vm._m(12),
        _c("div", { staticClass: "column is-6" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.userData.taxID,
                expression: "userData.taxID"
              }
            ],
            staticClass: "input",
            attrs: { type: "text" },
            domProps: { value: _vm.userData.taxID },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.userData, "taxID", $event.target.value)
              }
            }
          })
        ])
      ]),
      _c("div", { staticClass: "columns" }, [
        _vm._m(13),
        _c("div", { staticClass: "column is-6" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.userData.phone,
                expression: "userData.phone"
              }
            ],
            staticClass: "input",
            attrs: { type: "text", placeholder: "02-123-4567" },
            domProps: { value: _vm.userData.phone },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.userData, "phone", $event.target.value)
              }
            }
          })
        ])
      ]),
      _c("div", { staticClass: "columns" }, [
        _vm._m(14),
        _c("div", { staticClass: "column is-6" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.userData.fax,
                expression: "userData.fax"
              }
            ],
            staticClass: "input",
            attrs: { type: "text" },
            domProps: { value: _vm.userData.fax },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.userData, "fax", $event.target.value)
              }
            }
          })
        ])
      ]),
      _c("div", { staticClass: "columns" }, [
        _vm._m(15),
        _c("div", { staticClass: "column is-6" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.userData.businessType,
                expression: "userData.businessType"
              }
            ],
            staticClass: "input",
            attrs: { type: "text" },
            domProps: { value: _vm.userData.businessType },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.userData, "businessType", $event.target.value)
              }
            }
          })
        ])
      ]),
      _c("div", { staticClass: "columns" }, [
        _vm._m(16),
        _c("div", { staticClass: "column is-6" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.userData.billing,
                expression: "userData.billing"
              }
            ],
            staticClass: "input",
            attrs: { type: "text" },
            domProps: { value: _vm.userData.billing },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.userData, "billing", $event.target.value)
              }
            }
          })
        ])
      ]),
      _c("div", { staticClass: "columns" }, [
        _vm._m(17),
        _c("div", { staticClass: "column is-6" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.userData.contactName,
                expression: "userData.contactName"
              }
            ],
            staticClass: "input",
            attrs: { type: "text" },
            domProps: { value: _vm.userData.contactName },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.userData, "contactName", $event.target.value)
              }
            }
          })
        ])
      ]),
      _c("div", { staticClass: "columns" }, [
        _vm._m(18),
        _c("div", { staticClass: "column is-6" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.userData.contactPosition,
                expression: "userData.contactPosition"
              }
            ],
            staticClass: "input",
            attrs: { type: "text" },
            domProps: { value: _vm.userData.contactPosition },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.userData, "contactPosition", $event.target.value)
              }
            }
          })
        ])
      ]),
      _c("div", { staticClass: "columns" }, [
        _vm._m(19),
        _c("div", { staticClass: "column is-6" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.userData.contactEmail,
                expression: "userData.contactEmail"
              }
            ],
            staticClass: "input",
            attrs: { type: "email" },
            domProps: { value: _vm.userData.contactEmail },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.userData, "contactEmail", $event.target.value)
              }
            }
          })
        ])
      ]),
      _c("div", { staticClass: "columns" }, [
        _vm._m(20),
        _c("div", { staticClass: "column is-6" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.userData.contactPhone,
                expression: "userData.contactPhone"
              }
            ],
            staticClass: "input",
            attrs: { type: "email" },
            domProps: { value: _vm.userData.contactPhone },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.userData, "contactPhone", $event.target.value)
              }
            }
          })
        ])
      ]),
      _c("div", { staticClass: "columns" }, [
        _vm._m(21),
        _c("div", { staticClass: "column is-6" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.userData.ccEmail,
                expression: "userData.ccEmail"
              }
            ],
            staticClass: "input",
            attrs: { type: "email" },
            domProps: { value: _vm.userData.ccEmail },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.userData, "ccEmail", $event.target.value)
              }
            }
          })
        ])
      ]),
      _c("div", { staticClass: "columns" }, [
        _vm._m(22),
        _c("div", { staticClass: "column is-6" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.userData.remark,
                expression: "userData.remark"
              }
            ],
            staticClass: "input",
            attrs: { type: "text" },
            domProps: { value: _vm.userData.remark },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.userData, "remark", $event.target.value)
              }
            }
          })
        ])
      ]),
      _c("div", { staticClass: "columns" }, [
        _vm._m(23),
        _c("div", { staticClass: "column is-6" }, [
          _c("div", { staticClass: "select" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.userData.status,
                    expression: "userData.status"
                  }
                ],
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.userData,
                      "status",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  }
                }
              },
              [
                _c("option", { attrs: { value: "Active" } }, [
                  _vm._v("Active")
                ]),
                _c("option", { attrs: { value: "Delete" } }, [_vm._v("Delete")])
              ]
            )
          ])
        ])
      ]),
      _c("div", { staticClass: "columns" }, [
        _c("div", { staticClass: "column is-2" }),
        _c(
          "div",
          { staticClass: "column is-6" },
          [
            _c("isButton", {
              ref: "btnCreate",
              attrs: {
                onClick: _vm.CreateCustomer,
                state: "true",
                title: "Save"
              }
            }),
            _vm._v("\n              "),
            _c("span", { staticClass: "has-text-danger" }, [
              _vm._v(" " + _vm._s(_vm.submitStatus))
            ])
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "columns" }, [
      _c("div", { staticClass: "column is-12" }, [
        _c("h3", { staticClass: "title" }, [
          _c("b", [
            _c("i", { staticClass: "fa fa-user" }),
            _vm._v("  Edit Customer")
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-2" }, [
      _c("b", [_vm._v("Customer Email: *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-2" }, [
      _c("b", [_vm._v("Password: *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-2" }, [
      _c("b", [_vm._v("Confirm Password: *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-2" }, [
      _c("b", [_vm._v("Company Name: *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-2" }, [
      _c("b", [_vm._v("FirstName: *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-2" }, [
      _c("b", [_vm._v("LastName: *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-2" }, [
      _c("b", [_vm._v("Branch: *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-2" }, [
      _c("b", [_vm._v("Address: ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-2" }, [_c("b")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-2" }, [_c("b")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-2" }, [_c("b")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-2" }, [
      _c("b", [_vm._v("TaxID: ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-2" }, [
      _c("b", [_vm._v("Phone: *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-2" }, [
      _c("b", [_vm._v("Fax: *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-2" }, [
      _c("b", [_vm._v("BusinessType: *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-2" }, [
      _c("b", [_vm._v("Delivery & Billng procedure: ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-2" }, [
      _c("b", [_vm._v("Contact Name: *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-2" }, [
      _c("b", [_vm._v("Contact Position: ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-2" }, [
      _c("b", [_vm._v("Contact Email: ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-2" }, [
      _c("b", [_vm._v("Contact Phone: ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-2" }, [
      _c("b", [_vm._v("CC email: ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-2" }, [
      _c("b", [_vm._v("Remark")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-2" }, [
      _c("b", [_vm._v("Status")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c8fa09c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8fa09c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/admin/customer/edit/_id.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-c8fa09c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/admin/customer/edit/_id.vue
// module chunks = 10